module.exports = __webpack_public_path__ + "media/images/social-media/facebook_small-705abf9c173581f8cf70887c7db500c3.png";